import { createContext, useState } from "react";

const WaitingContext = createContext({
    waitingPatient:[],
    OnAddedcheckUp:(data) => {},
});

export default WaitingContext;

export const WaitingPatientContextProvider = (props) => {
    const [waitingData, setWaitingData] = useState();
    const OnAddedcheckUpHandler  = (data) => {
        setWaitingData(data);
    }
   return(
    <WaitingContext.Provider value={{
        waitingPatient:waitingData,
        OnAddedcheckUp:OnAddedcheckUpHandler
    }}>
        {props.children}
        </WaitingContext.Provider>
   ); 
}